import React from 'react';

export const Bag: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="3 3 18 18" {...props}>
    <path d="M10.575 12.457h2.851v.95h-2.851zm0 0" fill="currentColor" />
    <path
      d="M16.981 13.421h-2.637v.465a.467.467 0 01-.469.465h-3.75a.467.467 0 01-.469-.465v-.465H7.02a1.4 1.4 0 01-1.334-.953L4 7.452v10.153A1.4 1.4 0 005.406 19h13.188A1.4 1.4 0 0020 17.605V7.453l-1.686 5.015a1.4 1.4 0 01-1.334.953zm0 0"
      fill="currentColor"
    />
    <path
      d="M13.873 5h-3.745a1.417 1.417 0 00-1.4 1.426V6.9h-3.91l1.765 5.044a.469.469 0 00.444.325H9.66v-.475a.471.471 0 01.468-.475h3.744a.471.471 0 01.468.475v.476h2.633a.469.469 0 00.444-.325L19.183 6.9h-3.906v-.474A1.417 1.417 0 0013.873 5zM9.66 6.9v-.474a.472.472 0 01.468-.476h3.744a.472.472 0 01.468.475V6.9zm0 0"
      fill="currentColor"
    />
  </svg>
);
